import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { Button, Box, Typography } from "@material-ui/core/"
import DialogsContainerDialog from "../DialogsContainer"
import { toggleFacebookConnected } from "actions/facebookConnectedDialog"
import useStyles from "./styles"

const FacebookConnected = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { open } = useSelector(state => ({
    open: state.facebookConnectedDialog.open
  }))

  const handleClose = () => {
    dispatch(toggleFacebookConnected())
  }

  const handleRefresh = () => {
    dispatch(toggleFacebookConnected())
    window.location.reload()
  }

  return (
    <DialogsContainerDialog
      open={open}
      handleClose={handleClose}
      title="Connecting to Facebook"
      content={
        <Typography variant="caption" className={classes.textExplanation}>
          Please click refresh after you have finished connecting to Facebook.
        </Typography>
      }
      buttons={
        <Box
          display="flex"
          justifyContent="center"
          marginTop="16px"
          width="100%"
        >
          <Button variant="contained" color="primary" onClick={handleRefresh}>
            Refresh
          </Button>
        </Box>
      }
      fullScreen={false}
    />
  )
}

export default FacebookConnected



// WEBPACK FOOTER //
// ./src/dialogs/FacebookConnected/index.jsx